import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  appBar: {
    background: theme.palette.ePrimary?.base,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    zIndex: "1202",
  },
  toolbar: {
    minHeight: "45px",
    justifyContent: "space-between",
  },
}));
export default function CardHeader({ data, searchContent, contentReady }) {
  let classes = useStyle();

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Grid container spacing={1} justify="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h6">{data?.title}</Typography>
          </Grid>
          <Grid item>
              {
              contentReady ?
              <Typography variant="caption">{
                data?.data.length === 1 ? 
                searchContent("E_SEARCH_SINGLE_RESULT_NUMBER").answer?.replace("<number>", data?.data.length) :
                searchContent("E_SEARCH_RESULTS_NUMBER").answer?.replace("<number>", data?.data.length)
              }</Typography>
              : <Skeleton />
              }
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}
